import React from 'react'
import { Stack, Tooltip } from '@mui/material'
import FileCopyIcon from '@mui/icons-material/FileCopy';
import CloseIcon from '@mui/icons-material/Close';
import useNodeCRUD from '../../hooks/useNodeCRUD';

export default function NodeWrapper({ nodeId, children }) {
    const { onNodeClone, onNodeDelete } = useNodeCRUD()
    return (
        <Stack position={'relative'}>
            <Tooltip title={<>Delete node<span style={{ opacity: 0.6, marginLeft: 6, fontSize: 10 }}>Del</span></>} placement="top">
                <div className='ghost-btn close' onClick={() => onNodeDelete(nodeId)}>
                    <CloseIcon sx={{ width: 12, height: 12 }} />
                </div>
            </Tooltip>
            <Tooltip title={<>Duplicate node<span style={{ opacity: 0.6, marginLeft: 6, fontSize: 10 }}>Ctrl+D</span></>} placement="top">
                <div className='ghost-btn clone' onClick={e => onNodeClone(e, nodeId)}>
                    <FileCopyIcon sx={{ width: 10, height: 10 }} />
                </div>
            </Tooltip>
            {children}
        </Stack>
    )
}
